import { ArrowsPointingInIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedProvidersMergedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface ProvidersMergedEventProps {
  event: DiscriminatedProvidersMergedEvent;
}

export const ProvidersMergedEvent: React.FC<ProvidersMergedEventProps> = ({
  event,
}) => {
  const { provider } = event.payload;
  const sourceCount = event.payload.source_provider_ids?.length || 0;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-purple-100">
          <ArrowsPointingInIcon className="h-4 w-4 text-purple-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityTitle>{provider.name}</ActivityTitle>
      <ActivityDescription>
        <div className="text-xs text-gray-500">
          Merged {sourceCount} provider{sourceCount !== 1 ? 's' : ''}
        </div>
      </ActivityDescription>
    </ActivityBody>
  );

  const actions = event.payload.target_id && (
    <ActivityActions>
      <ActivityLink
        href={`/matters/${event.matter_id}/treatment/${event.payload.target_id}`}
      >
        View Provider
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Providers Merged"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
